export default __webpack_public_path__ + "static/media/rnr-sports-table-23.39aff40a.webp";